import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetDetailRedeem {
  id?: string;
  idTransaksi?: string;
}

export const getDetailRedeem = ({
  id = '',
  idTransaksi = ''
}: GetDetailRedeem) => {
  return HttpService.get(
    `${ApiService.icdc.module.inventoryReward.detail}?id=${id}&idTransaksi=${idTransaksi}`
  );
};

export const pickVoucher = (data: any) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.pick, data);
};

export const cancelVoucher = (data) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.cancel, data);
};
